export default __webpack_public_path__ + "static/media/EPICNY_Site_Logo.90b93318.png";